import React from 'react';

import InternalBackupDashboardContainer from '@totem/components/services/backup/internalDashboard/InternalBackupDashboardContainer';
import InternalBackupDashboardLayout, {
  InternalBackupDashboardExtra,
} from '@totem/components/services/backup/internalDashboard/InternalBackupDashboardLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const InternalBackupDashboardPage = () => (
  <ContentLayout>
    <InternalBackupDashboardContainer>
      <IBCard
        isCovered
        title="Backup Dashboard"
        extra={<InternalBackupDashboardExtra />}
      >
        <InternalBackupDashboardLayout />
      </IBCard>
    </InternalBackupDashboardContainer>
  </ContentLayout>
);

export default InternalBackupDashboardPage;
